import clsx from 'clsx'

import { useStepSlider } from './Context'

interface DragConstraintProps {
  children: preact.ComponentChildren
  className?: string
}

export function DragConstraint({ children, className }: DragConstraintProps) {
  const { constraintRef } = useStepSlider()

  return (
    <div ref={constraintRef} className={clsx('w-full', className)}>
      {children}
    </div>
  )
}
